<div class="aca-content-header">
    <button *ngIf="(appNavNarMode$ | async) === 'collapsed'"
      mat-icon-button
      class="aca-content-header-button"
      (click)="toggleClick()"
      [attr.aria-label]="'APP.TOOLTIPS.EXPAND_NAVIGATION' | translate"
      title="{{'APP.TOOLTIPS.EXPAND_NAVIGATION' | translate}}"
      adf-auto-focus>
      <mat-icon>keyboard_double_arrow_right</mat-icon>
    </button>
    <ng-content select=".aca-page-layout-header, aca-page-layout-header" />
</div>

<ng-container *ngIf="hasError">
  <ng-content select=".aca-page-layout-error, aca-page-layout-error" />
</ng-container>

<ng-container *ngIf="!hasError">
  <ng-content select=".aca-page-layout-content, aca-page-layout-content" />
</ng-container>
